import { CanAccess, useTranslate } from "ra-core";
import { Navigate } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { MobileBackButton } from "../misc/MobileBackButton";
import { ProfileOptionList } from "./ProfileOptionList";

/**
 * Almikia Epic EF (TASK-121), DATA CONTRACT EF (1): "Opciones del perfil" --
 * a single direccion-only screen (`CanAccess` on `profile_buyer_types`/`edit`,
 * the same gate every one of the five catalogues shares, DATA CONTRACT EF
 * (4)) listing the five identical-shape catalogues, each rendered by the ONE
 * generic {@link ProfileOptionList} component. A custom route (not five
 * registered resources), like `AlmikiaPage`/`CulturePage` -- see the ADR for
 * why. Mounted in both shells (`CRM.tsx`), reached from Settings; NOT added
 * to the desktop top rail (ticket's own acceptance criterion).
 */
const CATALOGUES: { resource: string; titleKey: string }[] = [
  {
    resource: "profile_buyer_types",
    titleKey: "resources.profile_buyer_types.title",
  },
  {
    resource: "profile_credit_types",
    titleKey: "resources.profile_credit_types.title",
  },
  {
    resource: "profile_timelines",
    titleKey: "resources.profile_timelines.title",
  },
  {
    resource: "profile_motivators",
    titleKey: "resources.profile_motivators.title",
  },
  {
    resource: "profile_objections",
    titleKey: "resources.profile_objections.title",
  },
];

export const ProfileOptionsPage = () => (
  <CanAccess
    resource="profile_buyer_types"
    action="edit"
    accessDenied={<Navigate to="/" replace />}
  >
    <ProfileOptionsPageContent />
  </CanAccess>
);

ProfileOptionsPage.path = "/profile_options";

const ProfileOptionsPageContent = () => {
  const translate = useTranslate();
  const isMobile = useIsMobile();

  const body = (
    <div className="flex flex-col gap-4">
      {CATALOGUES.map((catalogue) => (
        <ProfileOptionList
          key={catalogue.resource}
          resource={catalogue.resource}
          titleKey={catalogue.titleKey}
        />
      ))}
    </div>
  );

  if (isMobile) {
    return (
      <>
        <MobileHeader>
          <MobileBackButton to="/settings" />
          <div className="flex flex-1 min-w-0">
            <h1 className="text-xl font-semibold truncate">
              {translate("crm.profileOptions.page_title")}
            </h1>
          </div>
        </MobileHeader>
        <MobileContent>{body}</MobileContent>
      </>
    );
  }

  return (
    <div className="mx-auto max-w-2xl p-4 pb-8">
      <h1 className="text-2xl font-semibold mb-4">
        {translate("crm.profileOptions.page_title")}
      </h1>
      {body}
    </div>
  );
};
